module.exports = __webpack_public_path__ + "img/train-protocol.871bfa5f.jpeg";